var KlaviyoBackInStock = class extends HTMLElement {
    connectedCallback() {
        // Get the form inside the KlaviyoSubscription element
        const button = this.querySelector(".klaviyo-bis-trigger");
        const resetEmail = this.querySelector('.backinstock-customer__email-close')
        // Add a click event listener to the button
        button.addEventListener('click', (e) => this.triggerBackInStock());

        // if user is logged in, creates the x block, else do nothing
        if (resetEmail != null) {
            resetEmail.addEventListener('click', (e) => this.resetEmailFunction(e))
        }



    }

    triggerBackInStock(e) {
        // Your event handling code here
        const variantID = this.closest('form').querySelector('input[name="id"]');
        const productID = this.closest('form').querySelector('input[name="product_id"]');
        const email = this.querySelector('input[name="email"]');
        const emailValue = email ? email.value : this.querySelector('.backinstock-customer__email').textContent
        // Rest of your code
        if (email.classList.contains('is-filled')) {
            email.classList.remove('input-error')
            $.ajax({
                type: "POST",
                url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
                data: {
                    a: "QZH4ff",
                    email: emailValue,
                    variant: variantID.value,
                    product: productID.value,  // Product must be present in Klaviyo catalog to record event.
                    platform: "shopify",
                },
                success: function(response){
                    console.log(response)
                }
            })
        } else {
            email.classList.add('input-error');
            // Create and insert the error message
            const errorMessage = document.createElement('div');
            errorMessage.textContent = 'Please enter a valid email address';
            errorMessage.classList.add('error-message');

            // Insert the error message after the email input
            email.parentNode.insertBefore(errorMessage, email.nextSibling);
            email.focus()
            // Remove the error message after 5 seconds
            setTimeout(() => {
                errorMessage.remove();
            }, 5000);
        }

    }
    resetEmailFunction(e) {
        const close = e.currentTarget;
        const emailContainer = close.closest('.backinstock-customer__email-container');
        const emailElements = emailContainer.children;
        for (let i = 0; i < emailElements.length; i++) {
            emailElements[i].classList.toggle('visually-hidden');
        }

    }
};

window.customElements.define("klaviyo-backinstock", KlaviyoBackInStock);
